<ng-container *ngIf="!OrderedItem then BasketItemsTemplate else OrderedItemsTemplate"></ng-container>
<ng-template #BasketItemsTemplate>
  <ng-container *ngIf="basketItem">
    <div class="ya-content-item">
      <div class="shippingcart-item-wrapper">
        <!--Menucourse-->
        <ng-container *ngIf="isInHouseOrder ">
          <ng-container *ngIf="basketItem.use_menucourse">
            <ng-container *ngIf="menucourses$ | async; let menucourses">
              <mat-button-toggle-group multiple
                (change)="!isInHouseGroupOrder && canModifyBasket?toggleGroupChange($event, basketItem):''">
                <mat-button-toggle *ngFor="let menucourse of (menucourses$ | async);" [value]="menucourse.id"
                  [disabled]="isInHouseGroupOrder ||!canModifyBasket"
                  [checked]="menucourse.id == basketItem.menucourse">
                  <span>{{menucourse.name}}</span>
                </mat-button-toggle>
              </mat-button-toggle-group>
            </ng-container>
          </ng-container>
        </ng-container>
        <!-- Basket item details: deposit, price & extras -->
        <div class="shippingcart-content-detail" [class.customize-space]="customSpace(basketItem)">
          <h2>{{ basketItem.label}}</h2>
          <ng-container *ngIf="basketItem.valid_date && basketItem.valid_date != 0">
            <div class="deposit">{{formatItemDate(basketItem.valid_date)}}</div>
          </ng-container>
          <ng-container *ngIf="basketItem.deposit && basketItem.deposit> 0">
            <div class="deposit">{{getDepositText(basketItem.deposit,basketItem.count)}}</div>
          </ng-container>
          <ng-container *ngIf="displayVariablePrice(basketItem.variable_price)">
            <div class="deposit">{{setItemPrice(basketItem.variable_price)}}</div>
          </ng-container>
          <ng-container *ngIf=" basketItem.extras &&  basketItem.extras.length > 0">
            <div class="extra-item-wrapper">
              <div [id]="'prucudtExtraContainer---' +  basketItem.id" class="extra-item-container active">
                <p>{{setExtraString(basketItem.extras)}}</p>
              </div>
            </div>
          </ng-container>
          <!--Webvoucher content-->
          <ng-container *ngIf="basketItem.isWebVoucher">
            <div class="webVoucher-content">
              <ng-container *ngIf="basketItem.show_person_count">
                <div class="webVoucher-content--detail">
                  <span class="person-count">{{basketItem.person_count}}</span><span
                    [langkey]="basketItem.person_count>1? 'phWebvoucher_Detail_Selected_Number_Of_Persons' :'phWebvoucher_Detail_Selected_Single_Person'"></span>
                </div>
              </ng-container>
              <ng-container *ngIf="basketItem.show_delivery_type">
                <div class="webVoucher-content--detail">
                  <span
                    [langkey]="isWebVoucherMailDelivery(basketItem.delivery_type)?'phWebvoucher_Detail_Email_Delivery':'phWebvoucher_Detail_Post_Delivery'"></span>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <!--Coupon line indicator-->
          <ng-container *ngIf="basketItem.coupon_id">
            <span class="basket-item-coupon-label" langkey="phCoupon_BasketLine_Label"></span>
          </ng-container>
          <!--Comment section-->
          <ng-container *ngIf="allowBasketModification && canDisplayNote()">
            <ng-container
              *ngIf="canModifyBasket && !isInHouseGroupOrder then commentTemplate else viewCommentTemplate"></ng-container>
            <ng-template #commentTemplate>
              <ng-container *ngIf=" basketItem.canComment">
                <!-- Display comment text or notice link  -->
                <ng-container *ngIf="!isEditing(basketItem.id) && hasContent(basketItem.comment)">
                  <div [id]="'comment'+ basketItem.id" class="item-comment"> <span
                      (click)="showTextarea(basketItem.id)">
                      {{ basketItem.comment }}
                    </span>
                  </div>
                </ng-container>
                <ng-container *ngIf="!isEditing(basketItem.id) && !hasContent(basketItem.comment)">
                  <div [id]="'commentLink'+basketItem.id" class="item-comment-link">
                    <a a11y_Button (click)="showTextarea(basketItem.id)">
                      <span class="ya-caption" langkey="phWebshop_Item_Show_Comment"></span>
                    </a>
                  </div>
                </ng-container>
                <!-- Textarea for editing/adding a comment -->
                <textarea a11y_Input *ngIf="isEditing(basketItem.id)" [value]="basketItem.comment"
                  class="ya-caption comment-area"
                  [ngClass]="{'show-comment': isEditing(basketItem.id), 'hide-comment': !isEditing(basketItem.id)}"
                  minlength="1" maxlength="200" id="commentTextarea-{{ basketItem.id}}"
                  (blur)="onBlur(basketItem,$event.currentTarget.value)"></textarea>
              </ng-container>
            </ng-template>
            <!-- item comment-->
            <ng-template #viewCommentTemplate>
              <ng-container *ngIf="hasContent(basketItem.comment)">
                <div [id]="'comment'+ basketItem.id" class="item-comment"> <span (click)="showTextarea(basketItem.id)">
                    {{ basketItem.comment }}
                  </span>
                </div>
              </ng-container>
            </ng-template>
          </ng-container>
        </div>
        <div class="shippingcart-item-content--detail">
          <div class="shippingcart-price-detail">
            <div class="item-count">{{ basketItem.count}}</div>
            <div class="item-amount">{{ !basketItem.isBenefit?
              setItemPrice(basketItem.price):benefitCostPoints(basketItem.benefitCostPoints)}}</div>
          </div>
        </div>
        <div class="additional-content">
          <div a11y_Button class="additional-info" (click)="viewDetails(basketItem)">
            <span>i</span>
          </div>
        </div>
        <!-- change item count -->
        <ng-container *ngIf="allowBasketModification && canModifyBasket">
          <div class="webshop-item-tool">
            <ng-container
              *ngIf="canChangeCount(basketItem.canDecrement) then removeCountEnabled else removeCountDisabled">
            </ng-container>
            <ng-template #removeCountEnabled>
              <div a11y_Button class="decrement-item" (click)="handleDecrementItem(basketItem)">
                <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-minus-voll">
                </div>
              </div>
            </ng-template>
            <ng-template #removeCountDisabled>
              <div a11y_Button class="decrement-item">
                <div class="inline-icon disabled" inlineSVG="shop-icons.svg#ya-hypersoft-minus-voll"></div>
              </div>
            </ng-template>
            <hr class="hr-seperator">
            <ng-container
              *ngIf="canChangeCount(basketItem.canIncrement)&& !isChargeWebVoucher && !basketItem.isBenefit;then addCountEnabled else addCountDisabled">
            </ng-container>
            <ng-template #addCountEnabled>
              <div a11y_Button class="increment-item" (click)="handleIncrementItem(basketItem)">
                <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-plus-voll">
                </div>
              </div>
            </ng-template>
            <ng-template #addCountDisabled>
              <div a11y_Button class="increment-item">
                <div class="inline-icon disabled" inlineSVG="shop-icons.svg#ya-hypersoft-plus-voll"></div>
              </div>
            </ng-template>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-template>
<!-- Ordered items -->
<!--The ordered items are currently displayed under the  IH order-->
<ng-template #OrderedItemsTemplate>
  <div class="ya-content-item ordered_item"
    [class.state-preparation_wrapper]="OrderedItem.state===stateValue.InPreperation"
    [class.state-pickUp_wrapper]="OrderedItem.state===stateValue.ReadyForPickUp||OrderedItem.state===stateValue.PickedUp">
    <ng-container *ngIf="OrderedItem.use_menucourse">
      <mat-button-toggle-group>
        <mat-button-toggle *ngFor="let menucourse of (menucourses$ | async);" [value]="menucourse.id"
          [checked]="menucourse.id == OrderedItem.menucourse" [disabled]="true">
          <span>{{menucourse.name}}</span>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </ng-container>
    <div class="shippingcart-item-wrapper">
      <div class="shippingcart-content-detail">
        <h2>{{OrderedItem.label}}</h2>
        <ng-container *ngIf="OrderedItem.valid_date && OrderedItem.valid_date != 0">
          <div class="deposit">{{formatItemDate(OrderedItem.valid_date)}}</div>
        </ng-container>
        <ng-container *ngIf="OrderedItem.deposit &&  OrderedItem.deposit!=0">
          <div class="deposit">{{getDepositText(OrderedItem.deposit,OrderedItem.count)}}</div>
        </ng-container>
        <ng-container *ngIf="OrderedItem.extras && OrderedItem.extras.length > 0">
          <div class="extra-item-wrapper">
            <div [id]="'prucudtExtraContainer---' +  OrderedItem.id" class="extra-item-container active">
              <p>{{setExtraString(OrderedItem.extras)}}</p>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="hasContent(OrderedItem.comment)">
          <p class="ya-caption">{{OrderedItem.comment}}</p>
        </ng-container>
      </div>
      <div class="shippingcart-price-detail">
        <div class="item-count">{{OrderedItem.count}}</div>
        <div class="item-amount">{{setItemPrice(OrderedItem.price)}}</div>
      </div>
    </div>
    <ng-container *ngIf="OrderedItem.state === stateValue.InPreperation">
      <div class="ya-icon-button state_preparation__icon">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-inzubereitung">
          </div>
          <div class="state_label">
            <span langkey="phGroupOrder_MemberOrder_Detail_State_Preparation"></span>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="OrderedItem.state === stateValue.ReadyForPickUp">
      <div class="ya-icon-button state_pickUp">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-abholbereit">
          </div>
          <div class="state_label">
            <span langkey="phGroupOrder_MemberOrder_Detail_State_Pickup"></span>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="OrderedItem.state === stateValue.PickedUp">
      <div class="ya-icon-button state_pickUp pickedUp">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-abgeholt">
          </div>
          <div class="state_label">
            <span langkey="phGroupOrder_MemberOrder_Detail_State_PickedUp"></span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>